import { useContext } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { AppColorTheme } from "../../Colors";
import CommentIcon from "../../images/comment-icon.svg";
import TimeContainer from "../../TimeContainer";
import styles from "./comments.module.css";
import { WeekReflectionContext } from "./WeekReflectionContext";

export const CommentButton = ({ openComments, showCommentCount = false, storyName }) => {
    let timeOfDay = new TimeContainer().getTimeOfDay();
    const countColor = timeOfDay === 'morning' ? AppColorTheme[timeOfDay].LIGHT : AppColorTheme[timeOfDay].DARK;

    const { textInputs } = useContext(WeekReflectionContext);
    const location = useLocation();

    const isCommentButtonVisible = () => {
        if (location.pathname.includes('share')) {
            // on a story being viewed in share mode, show the button only if there is a comment available to read
            if (textInputs[storyName] && textInputs[storyName].length > 0) {
                return true;
            }
            return false;
        }
        
        return true;
    }

    return (
        isCommentButtonVisible() && 
        <button className={styles.commentButton} onClick={openComments}>
            {textInputs[storyName]?.length > 0 &&
                <div className={styles.commentButtonCountCircle}>
                    <span className={styles.commentButtonCount} style={{ color: countColor }}>1</span>
                </div>
            }
            <img src={CommentIcon} className={styles.commentIcon} />
        </button>
    )
}